import { StorageDTO, StorageWithDate } from 'interfaces';

export const parseStorageDTOIntoStorageWithDate: (
   storageDTO: StorageDTO,
) => StorageWithDate = storageDTO => ({
   ...storageDTO,
   date: new Date(),
});
